import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { UnitMultiStepForm } from '../../app/components/unit/unit-multi-step-form';
import { trpc } from '@org/clients/school';

export const Route = createFileRoute('/units/new')({
  component: UnitCreateRoute,
});

function UnitCreateRoute() {
  const navigate = useNavigate({ from: '/units/new' });
  const utils = trpc.useUtils();

  const handleClose = () => {
    navigate({ to: '/units', replace: true });
  };

  const handleSubmit = async () => {
    await utils.units.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title="Create Unit"
      size="xl"
      centered
      body={
        <UnitMultiStepForm
          defaultValues={{}}
          onSubmit={handleSubmit}
          onClose={handleClose}
          isEditing={false}
        />
      }
      footer={<></>}
    />
  );
}


